/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Phase_Save_ErrorInputs */

const vi_toast_phase_save_error = /** @type {(inputs: Toast_Phase_Save_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu giai đoạn thất bại`)
};

/**

* @param {Toast_Phase_Save_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_phase_save_error = /** @type {((inputs?: Toast_Phase_Save_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Phase_Save_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_phase_save_error(inputs)
});